<template>
  <v-content>
    <v-container fluid>
      <h1 class="py-3">
        <span>{{title}} for Device:</span>
        <span class="font-weight-light pa-2 ma-2">{{$route.params.deviceID}}</span>
        <span>{{$route.params.displayname}}</span>
      </h1>
      <h4>Between {{ dateFrom | prettyPrintAPIDate('DD/MM/YYYY') }} and {{ dateTo | prettyPrintAPIDate('DD/MM/YYYY') }}</h4>
      <v-alert v-if="error" :value="true" type="error">{{ error }}</v-alert>
      <DeviceMessagesGraph
        v-else
        :title="title"
        :dateFrom="dateFrom"
        :dateTo="dateTo"
        :deviceID="$route.params.deviceID"
        :deviceType="$route.params.devicetype"
        v-on:error="errorHandler"
      />
    </v-container>
  </v-content>
</template>

<script>
import DeviceMessagesGraph from './DeviceMessagesGraph'
export default {
  name: 'DeviceTypeGraph',
  components: { DeviceMessagesGraph },
  data () {
    return {
      error: false,
      title: `${this.$route.params.devicetype} Graph`,
      dateFrom: this.$route.query.datefrom,
      dateTo: this.$route.query.dateto
    }
  },
  methods: {
    errorHandler (error) {
      // eslint-disable-next-line
      console.log(`Error(${error} - requesting device messages)`)
      // Inspect the error response.
      var errorStr = 'Request to backend failed.'
      if (error.response && error.response.data) {
        if (error.response.data.error) {
          errorStr = errorStr + ` Error: ${error.response.data.error}.`
        }
        if (error.response.data.message) {
          errorStr = errorStr + ` Message: ${error.response.data.message}.`
        }
        this.error = errorStr
      } else {
        this.error = error + ' - please retry again or with new date range.'
      }
    }
  }
}
</script>
